<template>
  <div>
  </div>
</template>

<script>
import authentication from '@/store/authentication'

export default {
  name: 'signup',
  created: function () {
    this.$session.destroy()
    this.$store.state.configAuth.redirectUri = this.$store.state.configAuth.redirectUriLogout
    authentication.initialize(this.$store.state.configAuth).then(_ => { }).catch(e => console.log(e))
    authentication.signOut()
  },
}
</script>

<style lang="scss">
</style>
